<mat-form-field>
    <mat-label>{{placeholder}}</mat-label>
    <input (click)="showPopUp()" [value]="registro" matInput readonly>
</mat-form-field>